var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,11c.067,1.293,7.938,1.291,8,0C12.433,9.707,4.562,9.709,4.5,11Zm7-6c.067,1.293,7.938,1.291,8,0C19.433,3.707,11.562,3.709,11.5,5ZM24,5v8c0,2.492-2.948,4.516-7,4.922C18.238,25.678.277,25.9,0,19V11C0,8.5,2.974,6.486,7,6.079,5.76-1.679,23.723-1.9,24,5ZM9,5a1.587,1.587,0,0,0,.461,1.032A10.661,10.661,0,0,1,15.329,8c3.742.088,6.726-1.558,6.671-3C21.577,1.057,9.419,1.06,9,5ZM2,11c.424,3.944,12.581,3.939,13,0C14.576,7.056,2.419,7.061,2,11Zm13,8V14.251c-2.963,2.292-10.037,2.292-13,0V19C2.422,22.943,14.582,22.939,15,19Zm7-6V8.251a10.868,10.868,0,0,1-5.188,1.686c.357.663.127,5.183.188,5.974C20.029,15.561,22,14.209,22,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.9ab48f745eb2064617391f491e45ff35.svg";
export { ForwardRef as ReactComponent };